var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.699 457.531C144.262 460.125 145.074 465.125 142.48 468.688C140.918 470.844 138.48 472 136.011 472C134.386 472 132.729 471.5 131.323 470.5C127.26 467.563 32 397.123 32 255.995S127.26 44.428 131.323 41.491C134.854 38.959 139.886 39.709 142.48 43.303C145.074 46.866 144.262 51.866 140.699 54.46C139.792 55.147 48.002 123.336 48.002 255.995S139.792 456.844 140.699 457.531Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketRound);
export default __webpack_public_path__ + "static/media/bracket-round.d09d511a69882c5d14ef5cb80e29e60f.svg";
export { ForwardRef as ReactComponent };